module.exports = __webpack_public_path__ + "img/liveend_icon.fcec76da.png";